import React, { ReactNode } from "react";
import { SxProps } from '@mui/material';
import BoxComponent from "../Box/BoxComponent";
import { Theme } from "@emotion/react";

interface SvgProps {
    sx?: SxProps<Theme>;
    icon: ReactNode;
}

const SvgComponent = (props: SvgProps) => {
    return <BoxComponent
        component="div"
        sx={props.sx}
    >
        {props.icon}
    </BoxComponent>
}

export default SvgComponent;